import { createSlice } from "@reduxjs/toolkit";

const spotsInits = {
  adminSpots: [],
  mySpots: [],
};

const reducers = {
  getUserSpotsList: (state, action) => {
    const newItems = action.payload.items;

    state.mySpots = newItems;
  },
  delteUserSpotItem: (state, action) => {
    const tempMySpots = [...state.mySpots];
    const spotId = action.payload.id;

    const updatedLlist = tempMySpots.filter((item) => item.id !== spotId);

    state.mySpots = updatedLlist;
  },
  getAdminSpotsList: (state, action) => {
    const newItems = action.payload.items;

    state.adminSpots = newItems;
  },
  delteAdminSpotItem: (state, action) => {
    const tempMySpots = [...state.adminSpots];
    const spotId = action.payload.id;

    const updatedLlist = tempMySpots.filter((item) => item.id !== spotId);

    state.adminSpots = updatedLlist;
  },
  // delteSpotsItem:(state,action) => {},
};

const spotsSlice = createSlice({
  name: "spots",
  initialState: spotsInits,
  reducers,
});

export const {
  getUserSpotsList,
  delteUserSpotItem,
  getAdminSpotsList,
  delteAdminSpotItem,
} = spotsSlice.actions;

export default spotsSlice.reducer;
